import PropTypes from 'prop-types';

const RadioOffSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 26}`}
      height={`${height || 26}`}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="1" width="24" height="24" rx="12" stroke={color} />
    </svg>
  );
};

RadioOffSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default RadioOffSvg;
